/* VELZEEN privacy-safe persistent error reporting client. */
(function (window, document) {
  'use strict';

  var guard = window.VelzeenWebview = window.VelzeenWebview || {};
  var STORAGE_PREFIX = 'velzeen:error-reporter:';
  var LOG_KEY = STORAGE_PREFIX + 'log';
  var CORRELATION_KEY = STORAGE_PREFIX + 'correlation';
  var RATE_KEY = STORAGE_PREFIX + 'rate';
  var DUPLICATE_KEY = STORAGE_PREFIX + 'duplicates';
  var SESSION_LIMIT = 25;
  var WINDOW_LIMIT = 8;
  var WINDOW_MS = 60000;
  var DUPLICATE_MS = 300000;
  var log = window.__VELZEEN_ERROR_LOG__ || [];
  var busy = false;
  var sentCount = 0;
  var blockedCount = 0;
  var duplicateCount = 0;
  var rateLimitedCount = 0;
  var lastTransport = 'not_attempted';
  var ua = String((window.navigator && window.navigator.userAgent) || '');

  function rawText(value, limit) {
    var output = '';
    try { output = String(value == null ? '' : value); } catch (ignore) { output = '[unavailable]'; }
    return limit && output.length > limit ? output.slice(0, limit) : output;
  }

  function scrub(value, limit) {
    var output = rawText(value, limit || 4000);
    output = output
      .replace(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi, '[redacted-email]')
      .replace(/\b(?:\d[ -]*?){13,19}\b/g, '[redacted-number]')
      .replace(/(?:\+?\d[\d\s().-]{7,}\d)/g, '[redacted-phone]')
      .replace(/\b(authorization|password|passwd|secret|api[_-]?key|token|session[_-]?id|checkout[_-]?token|cart[_-]?token|customer[_-]?id)\b\s*[:=]\s*(?:\"[^\"]*\"|'[^']*'|[^\s&,;]+)/gi, '$1=[redacted]')
      .replace(/\b(first[_-]?name|last[_-]?name|address1|address2|phone|email)\b\s*[:=]\s*(?:\"[^\"]*\"|'[^']*'|[^\s&,;]+)/gi, '$1=[redacted]');
    return limit && output.length > limit ? output.slice(0, limit) : output;
  }

  function storageGet(key, fallback) {
    try {
      var raw = window.sessionStorage && window.sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (ignore) { return fallback; }
  }

  function storageSet(key, value) {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (ignore) {}
  }

  function randomId(prefix) {
    var bytes;
    try {
      bytes = new Uint8Array(12);
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        window.crypto.getRandomValues(bytes);
        return prefix + Array.prototype.map.call(bytes, function (value) {
          var hex = value.toString(16);
          return hex.length < 2 ? '0' + hex : hex;
        }).join('');
      }
    } catch (ignore) {}
    return prefix + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  function correlationId() {
    var value = storageGet(CORRELATION_KEY, '');
    if (!value || typeof value !== 'string') {
      value = randomId('vz_');
      storageSet(CORRELATION_KEY, value);
    }
    return rawText(value, 80);
  }

  function meta(name) {
    var node = document.querySelector ? document.querySelector('meta[name="' + name + '"]') : null;
    return rawText(node && node.getAttribute('content') || '', 1000);
  }

  function endpoint() {
    var configured = rawText(window.VELZEEN_ERROR_ENDPOINT || meta('velzeen-error-endpoint') || '', 1000).trim();
    if (!configured) return '';
    try {
      var parsed = new window.URL(configured, window.location && window.location.origin || undefined);
      if (parsed.protocol !== 'https:' && parsed.origin !== (window.location && window.location.origin)) return '';
      if (parsed.username || parsed.password) return '';
      parsed.hash = '';
      return parsed.href;
    } catch (ignore) { return ''; }
  }

  function safeUrl(value) {
    try {
      var parsed = new window.URL(value, window.location && window.location.origin || undefined);
      return rawText(parsed.origin + parsed.pathname, 1200);
    } catch (ignore) { return ''; }
  }

  function templateName() {
    var value = meta('velzeen-template');
    if (!value && window.Theme && window.Theme.template) value = window.Theme.template.name;
    if (!value && document.body) {
      var match = rawText(document.body.className).match(/(?:^|\s)template-([^\s]+)/);
      value = match && match[1] || '';
    }
    return rawText(value || 'unknown', 120);
  }

  function productHandle() {
    var value = meta('velzeen-product-handle');
    if (!value) {
      var match = rawText(window.location && window.location.pathname).match(/\/products\/([^/?#]+)/i);
      value = match && match[1] || '';
    }
    return rawText(value, 180);
  }

  function buildRevision() {
    return rawText(meta('velzeen-build-revision') || 'velzeen-performance-cleanup-v2-20260726.2', 120);
  }

  function fallbackReason() {
    var value = guard.fallback && guard.fallback.reason || guard.fallbackReason || '';
    if (!value && document.documentElement) {
      value = document.documentElement.getAttribute('data-vz-fallback-reason') || '';
    }
    return rawText(value, 240);
  }

  function capabilities() {
    var source = guard.capabilities || {};
    return {
      modules: Boolean(source.modules),
      customElements: Boolean(source.customElements),
      promise: Boolean(source.promise),
      fetch: Boolean(source.fetch),
      enhanced: Boolean(source.enhanced),
      inApp: Boolean(guard.isInApp)
    };
  }

  function navigationType() {
    try {
      var entries = window.performance && window.performance.getEntriesByType ? window.performance.getEntriesByType('navigation') : [];
      if (entries && entries[0] && entries[0].type) return rawText(entries[0].type, 40);
    } catch (ignore) {}
    return 'unknown';
  }

  function platform() {
    if (/iPhone|iPad|iPod/i.test(ua)) return 'iOS';
    if (/Android/i.test(ua)) return 'Android';
    if (/Windows/i.test(ua)) return 'Windows';
    if (/Macintosh|Mac OS X/i.test(ua)) return 'macOS';
    return 'other';
  }

  function sensitivePage() {
    var path = rawText(window.location && window.location.pathname).toLowerCase();
    return /^\/(?:checkout|checkouts|account)(?:\/|$)/.test(path);
  }

  function hash(value) {
    var result = 2166136261;
    var input = rawText(value, 12000);
    for (var index = 0; index < input.length; index += 1) {
      result ^= input.charCodeAt(index);
      result = Math.imul(result, 16777619);
    }
    return ('00000000' + (result >>> 0).toString(16)).slice(-8);
  }

  function fingerprint(payload) {
    return hash([
      payload.type,
      payload.name,
      payload.message,
      payload.script,
      payload.line,
      payload.column,
      payload.template,
      payload.productHandle,
      payload.buildRevision,
      payload.fallbackReason
    ].join('|'));
  }

  function allowByDuplicate(id, now) {
    var duplicates = storageGet(DUPLICATE_KEY, {});
    if (!duplicates || typeof duplicates !== 'object') duplicates = {};
    var previous = Number(duplicates[id] || 0);
    Object.keys(duplicates).forEach(function (key) {
      if (now - Number(duplicates[key] || 0) > DUPLICATE_MS) delete duplicates[key];
    });
    if (previous && now - previous < DUPLICATE_MS) {
      duplicateCount += 1;
      storageSet(DUPLICATE_KEY, duplicates);
      return false;
    }
    duplicates[id] = now;
    storageSet(DUPLICATE_KEY, duplicates);
    return true;
  }

  function allowByRate(now) {
    var rate = storageGet(RATE_KEY, { timestamps: [], total: 0 });
    if (!rate || typeof rate !== 'object') rate = { timestamps: [], total: 0 };
    rate.timestamps = Array.isArray(rate.timestamps) ? rate.timestamps.filter(function (stamp) {
      return now - Number(stamp || 0) < WINDOW_MS;
    }) : [];
    rate.total = Number(rate.total || 0);
    if (rate.timestamps.length >= WINDOW_LIMIT || rate.total >= SESSION_LIMIT) {
      rateLimitedCount += 1;
      storageSet(RATE_KEY, rate);
      return false;
    }
    rate.timestamps.push(now);
    rate.total += 1;
    storageSet(RATE_KEY, rate);
    return true;
  }

  function storeLog() {
    storageSet(LOG_KEY, log.slice(-20));
  }

  function restoreLog() {
    var parsed = storageGet(LOG_KEY, []);
    if (Array.isArray(parsed)) log = parsed.slice(-20);
  }

  function transport(payload) {
    var url = endpoint();
    if (!url) {
      lastTransport = 'endpoint_missing';
      return false;
    }
    var body = JSON.stringify(payload);
    try {
      var parsedEndpoint = new window.URL(url, window.location && window.location.origin || undefined);
      var sameOrigin = parsedEndpoint.origin === (window.location && window.location.origin);
      if (sameOrigin && window.navigator && window.navigator.sendBeacon && window.Blob) {
        if (window.navigator.sendBeacon(url, new window.Blob([body], { type: 'application/json' }))) {
          lastTransport = 'beacon_queued';
          sentCount += 1;
          return true;
        }
      }
    } catch (ignore) {}
    try {
      if (window.fetch) {
        lastTransport = 'fetch_queued';
        sentCount += 1;
        window.fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: body,
          keepalive: true,
          credentials: 'omit',
          referrerPolicy: 'no-referrer'
        }).then(function (response) {
          lastTransport = response && response.ok ? 'fetch_accepted' : 'fetch_rejected';
        })['catch'](function () {
          lastTransport = 'fetch_failed';
        });
        return true;
      }
    } catch (ignore) {}
    lastTransport = 'transport_unavailable';
    return false;
  }

  function report(input) {
    if (busy) return null;
    busy = true;
    try {
      if (sensitivePage()) {
        blockedCount += 1;
        lastTransport = 'sensitive_page_blocked';
        return null;
      }

      var payload = {
        schemaVersion: 2,
        eventId: randomId('evt_'),
        timestamp: new Date().toISOString(),
        correlationId: correlationId(),
        type: scrub(input && input.type || 'javascript_error', 80),
        name: scrub(input && input.name || 'Error', 120),
        message: scrub(input && input.message || 'Unknown error', 1000),
        stack: scrub(input && input.stack || '', 4000),
        script: safeUrl(input && input.script || ''),
        line: Math.max(0, Number(input && input.line || 0)),
        column: Math.max(0, Number(input && input.column || 0)),
        url: safeUrl(window.location && window.location.href || ''),
        template: templateName(),
        productHandle: productHandle(),
        capabilities: capabilities(),
        navigationType: navigationType(),
        platform: platform(),
        buildRevision: buildRevision(),
        fallbackReason: fallbackReason()
      };
      payload.fingerprint = fingerprint(payload);

      var now = Date.now();
      if (!allowByDuplicate(payload.fingerprint, now)) {
        lastTransport = 'duplicate_suppressed';
        return null;
      }
      if (!allowByRate(now)) {
        lastTransport = 'rate_limited';
        return null;
      }

      log.push(payload);
      if (log.length > 20) log.splice(0, log.length - 20);
      window.__VELZEEN_ERROR_LOG__ = log;
      storeLog();

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'velzeen_javascript_error',
          error_type: payload.type,
          error_name: payload.name,
          error_fingerprint: payload.fingerprint,
          error_build_revision: payload.buildRevision,
          error_fallback_reason: payload.fallbackReason,
          webview_limited: !payload.capabilities.enhanced
        });
      } catch (ignore) {}
      try {
        if (typeof window.clarity === 'function') {
          window.clarity('set', 'velzeen_error_type', payload.type);
          window.clarity('set', 'velzeen_error_fingerprint', payload.fingerprint);
          window.clarity('event', 'velzeen_javascript_error');
        }
      } catch (ignore) {}

      transport(payload);
      return payload.eventId;
    } finally { busy = false; }
  }

  function previewEnabled() {
    var search = rawText(window.location && window.location.search);
    return Boolean(
      (window.Shopify && window.Shopify.designMode) ||
      document.documentElement.classList.contains('shopify-design-mode') ||
      /(?:^|[?&])preview_theme_id=/.test(search)
    );
  }

  restoreLog();
  guard.report = report;
  guard.getErrors = function () { return log.slice(0); };
  guard.getErrorReporterStatus = function () {
    var url = endpoint();
    return {
      endpointConfigured: Boolean(url),
      endpoint: url ? safeUrl(url) : '',
      buildRevision: buildRevision(),
      correlationId: correlationId(),
      sentCount: sentCount,
      blockedCount: blockedCount,
      duplicateCount: duplicateCount,
      rateLimitedCount: rateLimitedCount,
      lastTransport: lastTransport
    };
  };
  guard.triggerStagingError = function () {
    if (!previewEnabled()) return false;
    return report({
      type: 'staging_verification',
      name: 'VelzeenStagingVerification',
      message: 'Intentional privacy-safe staging error for endpoint verification.',
      stack: 'VelzeenStagingVerification@velzeen-webview-report.js',
      script: window.location && window.location.origin + '/assets/velzeen-webview-report.js'
    });
  };

  window.addEventListener('error', function (event) {
    var target = event && event.target;
    if (target && target !== window && (target.src || target.href)) {
      report({
        type: 'resource_error',
        name: target.tagName || 'ResourceError',
        message: 'Resource failed to load',
        script: target.src || target.href
      });
      return;
    }
    report({
      type: 'javascript_error',
      name: event.error && event.error.name || 'Error',
      message: event.message,
      stack: event.error && event.error.stack,
      script: event.filename,
      line: event.lineno,
      column: event.colno
    });
  }, true);

  window.addEventListener('unhandledrejection', function (event) {
    var reason = event.reason || {};
    report({
      type: 'unhandled_rejection',
      name: reason.name || 'UnhandledRejection',
      message: reason.message || reason,
      stack: reason.stack || ''
    });
  }, true);
})(window, document);
